import React, {Component} from 'react';
import { SlideToggle } from 'react-slide-toggle';
import {connect} from 'react-redux';
import {postExternalHash} from "../actions/externalHashId";
import {fetchAffiliatesByPos} from "../login/api.actions";
import {Tooltip} from 'react-tippy';
import 'react-tippy/dist/tippy.css';
import '../resources/stylesheets/config.css';


class CreateHashContainer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: '',
      externalHashId: ''
    };

    this.onChange = this.onChange.bind(this);
    this.saveNewHash = this.saveNewHash.bind(this);
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };


  saveNewHash(){
    const { name, externalHashId} = this.state;
    const { currentAffiliate, dispatch, showNotification } = this.props;

    if(currentAffiliate === undefined || name === '' || externalHashId === ''){
      showNotification('error', 'Please fill out all required fields');
    } else {

      dispatch(postExternalHash(name, externalHashId, currentAffiliate.affiliateId)).then((response) => {
        if(response && response.response === 'OK'){
          dispatch(fetchAffiliatesByPos(currentAffiliate.affiliateId));
          showNotification('success', 'Your unique identifier has been created successfully');
        } else {
          showNotification('error', response.error.message);
        }
      })
    }
  }

  render() {

    const { name, externalHashId } = this.state;

    return(
        <SlideToggle collapsed>
          {({onToggle, setCollapsibleElement}) => (
            <div className="my-collapsible createHashContainer">
                <button className="btn linkButtons" onClick={onToggle}><span>Create New Campaign</span></button>
              <Tooltip
              title="Create a new URL identifier to track your campaigns"
              position="right"
              trigger="click"
              size="big">
                <span className="glyphicon glyphicon-info-sign tooltip"></span>
              </Tooltip>

              <div className="my-collapsible__content createHashInner" ref={setCollapsibleElement}>
                <div className="my-collapsible__content-inner form-custom">
                  <div className="form-group col-xs-12 col-sm-12 col-lg-6">
                    <label htmlFor="name">Campaign Name:</label>
                    <input type="text" className="form-control" id="name" name="name" value={name} onChange={this.onChange}/>
                  </div>

                  <div className="form-group col-xs-12 col-sm-12 col-lg-6">
                    <label htmlFor="externalHashId">Campaign URL ID:</label>
                    <input type="text" className="form-control" id="externalHashId" name="externalHashId" value={externalHashId} onChange={this.onChange}/>
                  </div>

                  <button className="btn btn-success linkButtons" onClick={this.saveNewHash}><span>CREATE</span></button>
                </div>
              </div>
            </div>
          )}
        </SlideToggle>
    )
  };
}


const mapStateToProps = (state) => {

  const { affiliates } = state;

  return {
    currentAffiliate: affiliates && affiliates.currentAffiliate
  };
};

export default connect(mapStateToProps)(CreateHashContainer);